import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_phone-biz-system-1/artifacts/3zuzhakl_WhatsApp%20Image%202026-04-20%20at%2008.33.51.jpeg";

// Em produção (deploy always-on) o servidor não hiberna, então evitamos
// alarmar o usuário com "Servidor acordando".
export const IS_PREVIEW = !!(BACKEND_URL || "").includes("preview.emergentagent.com");

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 60000, // 60s — suficiente pra cold starts longos
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("upcel_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Retry automático em erros transitórios (cold start, timeout, gateway down)
let wakingUpNotified = false;
const TRANSIENT_STATUS = new Set([502, 503, 504]);
const RETRIABLE_METHODS = new Set(["get", "head", "options", "post", "patch"]);

api.interceptors.response.use(
  (resp) => {
    wakingUpNotified = false;
    return resp;
  },
  async (error) => {
    const cfg = error.config || {};
    const status = error.response?.status;
    const isNetwork = !error.response;
    const isTransient = isNetwork || TRANSIENT_STATUS.has(status);
    const method = (cfg.method || "get").toLowerCase();

    if (
      isTransient &&
      RETRIABLE_METHODS.has(method) &&
      !cfg.__noRetry &&
      (cfg.__retryCount || 0) < 4
    ) {
      cfg.__retryCount = (cfg.__retryCount || 0) + 1;

      if (!wakingUpNotified && cfg.__retryCount >= 2) {
        wakingUpNotified = true;
        try {
          const msg = IS_PREVIEW
            ? "Servidor acordando... aguarde 💤"
            : "Reconectando ao servidor...";
          toast.info(msg, { duration: 4000 });
        } catch {}
      }

      // Exponential backoff: 1s, 3s, 6s, 10s
      const wait = [1000, 3000, 6000, 10000][cfg.__retryCount - 1] || 10000;
      await new Promise((r) => setTimeout(r, wait));
      return api(cfg);
    }

    return Promise.reject(error);
  }
);

export function formatErr(detail) {
  if (!detail) return "Erro inesperado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export const brl = (v) =>
  (v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export default api;
